import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

export default class RecommendedWords extends React.Component {

  static propTypes = {
    recommendedWords: PropTypes.object,
    wordText: PropTypes.string
  }

  render() {
    if (this.props.recommendedWords && this.props.recommendedWords.size > 0) {
      const recommendedWords = this.props.recommendedWords
        .map((recommendedWord, i) => {
        return (
          <li key={ i } className='recommended-word'>
            <Link to={ `/words/${ recommendedWord }` }>
              { recommendedWord }
            </Link>
          </li>
        );
      });
      return (
        <div className='recommended-words secondary-background'>
          { `People who tacked ${ this.props.wordText } also tacked:` }
          <ol>
            { recommendedWords }
          </ol>
        </div>
      )
    } else return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/recommended_words.jsx